module.exports = __webpack_public_path__ + "media/theme/steps--2--open-d8e35a08.png";